import { AtsEmbedContext } from './atsEmbedContext';

// Another sub-account can use another Bullhorn instance with the same vacancy number.
export const getEmbeddedJobId = (
  embedContext: AtsEmbedContext | null,
  organizationId: string
): string | null =>
  embedContext?.organizationId === organizationId ? embedContext.jobId : null;
